import { EditorState } from "draft-js";

import { MutableRefObject, useEffect, useRef } from "react";
import { deserializeEditor, serializeEditor } from "components/editor/serializeEditor";
import getDecorator from "components/editor/decorators/getDecorator";

const useEditorSerializer = (textStory: string, bodyRef: MutableRefObject<null | string>) => {
  const containerRef = useRef();

  return useEffect(() => {
    const editorState = EditorState.set(deserializeEditor(textStory), {
      decorator: getDecorator({
        containerRef,
        onDecoratorSubscribe: () => {},
        onMentionCreated: () => {}
      })
    });

    serializeEditor(editorState, () => {})
      .then(body => {
        // eslint-disable-next-line no-param-reassign
        bodyRef.current = body;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textStory]);
};

export default useEditorSerializer;
